(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopddf-contact-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const directory = document.querySelector('.shopddf-contact-us__directory');
    if (!directory) return;

    const locationSelect = directory.querySelector('[data-contact-location]');
    const consulateSelect = directory.querySelector('[data-contact-consulate]');
    if (!locationSelect || !consulateSelect) return;

    let data = [];
    try {
      data = JSON.parse(directory.dataset.locations || '[]');
    } catch (error) {
      data = [];
    }

    const resetConsulate = () => {
      consulateSelect.innerHTML = '<option value="">Select Consulate / Mission</option>';
      consulateSelect.disabled = true;
    };

    const updateConsulates = (location) => {
      resetConsulate();
      if (!location) return;
      const match = data.find((entry) => entry.location === location);
      if (!match || !Array.isArray(match.consulates)) return;

      const options = match.consulates.filter(Boolean);
      if (!options.length) return;

      options.forEach((consulate) => {
        const option = document.createElement('option');
        option.value = consulate;
        option.textContent = consulate;
        consulateSelect.appendChild(option);
      });
      consulateSelect.disabled = false;
    };

    locationSelect.addEventListener('change', (event) => {
      updateConsulates(event.target.value);
    });

    if (locationSelect.value) {
      updateConsulates(locationSelect.value);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
